var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "d-flex flex-wrap align-center mb-3"
        },
        [
          _c(
            "h2",
            {
              staticClass: "body-1 mr-auto kvm-card-title"
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "pb-1",
                  attrs: {
                    size: "24",
                    color: "primary",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("mdi-key-variant")]
              ),
              _c(
                "span",
                {
                  staticClass: "ml-2"
                },
                [_vm._v("SSH Keys")]
              )
            ],
            1
          ),
          _c(
            "gg-btn",
            {
              attrs: {
                small: "",
                tile: "",
                color: "primary"
              },
              on: {
                click: _vm.openAdd
              }
            },
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    left: "",
                    small: "",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("mdi-plus")]
              ),
              _vm._v("Add SSH Key ")
            ],
            1
          )
        ],
        1
      ),
      _vm.selectable
        ? _c(
            "p",
            {
              staticClass: "kvm-help mb-2"
            },
            [
              _vm._v(
                " Tick the keys to install on this server. Keys are shared across all your services. "
              )
            ]
          )
        : _vm.server
        ? _c(
            "p",
            {
              staticClass: "kvm-help mb-2"
            },
            [
              _vm._v(
                " Your SSH keys are shared across all your servers. Switch a key on to install it on this server "
              ),
              _vm.loginUser
                ? [
                    _vm._v("(for "),
                    _c("strong", [_vm._v(_vm._s(_vm.loginUser))]),
                    _vm._v(")")
                  ]
                : _vm._e(),
              _vm._v("; switching it off removes it right away. ")
            ],
            2
          )
        : _vm._e(),
      _vm.server && _vm.liveError
        ? _c(
            "v-alert",
            {
              staticClass: "mb-3",
              attrs: {
                type: "info",
                border: "left",
                dense: ""
              }
            },
            [_vm._v(" " + _vm._s(_vm.liveError) + " ")]
          )
        : _vm._e(),
      _vm.loading
        ? _c(
            "div",
            {
              staticClass: "py-6 text-center",
              attrs: {
                role: "status",
                "aria-live": "polite"
              }
            },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  size: "32",
                  width: "3"
                }
              }),
              _c(
                "span",
                {
                  staticClass: "kvm-sr-only"
                },
                [_vm._v("Loading SSH keys…")]
              )
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "kvm-key-table"
            },
            [
              _c("v-simple-table", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function fn() {
                      return [
                        _c(
                          "caption",
                          {
                            staticClass: "kvm-sr-only"
                          },
                          [_vm._v("Your SSH keys")]
                        ),
                        _c("thead", [
                          _c("tr", [
                            _vm.selectable
                              ? _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    staticStyle: {
                                      width: "48px"
                                    },
                                    attrs: {
                                      scope: "col"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "kvm-sr-only"
                                      },
                                      [_vm._v("Select")]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "th",
                              {
                                staticClass: "text-left",
                                attrs: {
                                  scope: "col"
                                }
                              },
                              [_vm._v("Name")]
                            ),
                            _c(
                              "th",
                              {
                                staticClass: "text-left",
                                attrs: {
                                  scope: "col"
                                }
                              },
                              [_vm._v("Fingerprint")]
                            ),
                            _vm.server
                              ? _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    attrs: {
                                      scope: "col"
                                    }
                                  },
                                  [_vm._v("On this server")]
                                )
                              : _vm._e(),
                            _c(
                              "th",
                              {
                                staticClass: "text-right",
                                attrs: {
                                  scope: "col"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "kvm-sr-only"
                                  },
                                  [_vm._v("Actions")]
                                )
                              ]
                            )
                          ])
                        ]),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.keys, function(key) {
                              return _c(
                                "tr",
                                {
                                  key: key.id
                                },
                                [
                                  _vm.selectable
                                    ? _c(
                                        "td",
                                        {
                                          attrs: {
                                            "data-label": "Select"
                                          }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass:
                                              "mt-0 pt-0 kvm-key-check",
                                            attrs: {
                                              value: key.id,
                                              "hide-details": "",
                                              dense: "",
                                              label: "Install " + key.name
                                            },
                                            model: {
                                              value: _vm.selected,
                                              callback: function callback($$v) {
                                                _vm.selected = $$v
                                              },
                                              expression: "selected"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      attrs: {
                                        "data-label": "Name"
                                      }
                                    },
                                    [_vm._v(_vm._s(key.name))]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-caption kvm-fp",
                                      attrs: {
                                        "data-label": "Fingerprint"
                                      }
                                    },
                                    [_vm._v(_vm._s(key.fingerprint))]
                                  ),
                                  _vm.server
                                    ? _c(
                                        "td",
                                        {
                                          attrs: {
                                            "data-label": "On this server"
                                          }
                                        },
                                        [
                                          _c("v-switch", {
                                            staticClass:
                                              "mt-0 pt-0 kvm-key-switch",
                                            attrs: {
                                              "input-value": !!key.enabled,
                                              dense: "",
                                              "hide-details": "",
                                              inset: "",
                                              label: key.enabled ? "On" : "Off",
                                              "aria-label":
                                                (key.enabled
                                                  ? "Remove "
                                                  : "Install ") +
                                                key.name +
                                                " on this server",
                                              loading: _vm.busyKey === key.id,
                                              disabled:
                                                !!_vm.liveError ||
                                                _vm.busyKey != null
                                            },
                                            on: {
                                              change: function change(val) {
                                                return _vm.toggle(key, val)
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-right",
                                      attrs: {
                                        "data-label": "Actions"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            small: "",
                                            color: "error",
                                            "aria-label":
                                              "Remove SSH key " + key.name,
                                            title: "Remove"
                                          },
                                          on: {
                                            click: function click($event) {
                                              return _vm.askDelete(key)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                small: "",
                                                "aria-hidden": "true"
                                              }
                                            },
                                            [_vm._v("mdi-delete")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            }),
                            !_vm.keys.length
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "text-center kvm-help py-4 kvm-empty-cell",
                                      attrs: {
                                        colspan:
                                          _vm.selectable || _vm.server ? 4 : 3
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " No SSH keys yet. Add one so you can log in to your server. "
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "560",
            persistent: ""
          },
          model: {
            value: _vm.addDialog,
            callback: function callback($$v) {
              _vm.addDialog = $$v
            },
            expression: "addDialog"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "pa-4"
                },
                [
                  _c(
                    "h2",
                    {
                      staticClass: "body-1 mb-3 kvm-card-title"
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "pb-1",
                          attrs: {
                            color: "primary",
                            "aria-hidden": "true"
                          }
                        },
                        [_vm._v("mdi-key-plus")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "ml-1"
                        },
                        [_vm._v("Add SSH Key")]
                      )
                    ],
                    1
                  ),
                  _c("v-text-field", {
                    staticClass: "mb-2",
                    attrs: {
                      label: "Name",
                      placeholder: "e.g. work-laptop",
                      outlined: "",
                      dense: ""
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function callback($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name"
                    }
                  }),
                  _c("v-textarea", {
                    staticClass: "mb-1",
                    attrs: {
                      label: "Public key",
                      placeholder: "ssh-ed25519 AAAA… you@host",
                      outlined: "",
                      rows: "4",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.form.public_key,
                      callback: function callback($$v) {
                        _vm.$set(_vm.form, "public_key", $$v)
                      },
                      expression: "form.public_key"
                    }
                  }),
                  _c(
                    "p",
                    {
                      staticClass: "kvm-help text-caption mb-3"
                    },
                    [
                      _vm._v(" Paste the contents of your "),
                      _c("strong", [_vm._v("public")]),
                      _vm._v(
                        " key file (e.g. id_ed25519.pub). Never paste a private key. "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "text-right"
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            text: "",
                            disabled: _vm.submitting
                          },
                          on: {
                            click: _vm.closeAdd
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            tile: "",
                            color: "primary",
                            loading: _vm.submitting,
                            disabled: !_vm.canAdd
                          },
                          on: {
                            click: _vm.addKey
                          }
                        },
                        [_vm._v(" Add key ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "420",
            persistent: ""
          },
          model: {
            value: _vm.deleteDialog,
            callback: function callback($$v) {
              _vm.deleteDialog = $$v
            },
            expression: "deleteDialog"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "pa-4"
                },
                [
                  _c(
                    "h2",
                    {
                      staticClass: "body-1 mb-2 kvm-card-title"
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "pb-1",
                          attrs: {
                            color: "error",
                            "aria-hidden": "true"
                          }
                        },
                        [_vm._v("mdi-alert")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "ml-1"
                        },
                        [_vm._v("Remove SSH key")]
                      )
                    ],
                    1
                  ),
                  _vm.server
                    ? _c(
                        "p",
                        {
                          staticClass: "mb-4"
                        },
                        [
                          _vm._v(" Remove "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.keyToDelete && _vm.keyToDelete.name)
                            )
                          ]),
                          _vm._v(
                            " from your account? It's removed from this server now. Your other servers keep it until you switch it off there. "
                          )
                        ]
                      )
                    : _c(
                        "p",
                        {
                          staticClass: "mb-4"
                        },
                        [
                          _vm._v(" Remove "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.keyToDelete && _vm.keyToDelete.name)
                            )
                          ]),
                          _vm._v(
                            "? Existing servers keep it until you switch it off on them; it won't be installed on new builds. "
                          )
                        ]
                      ),
                  _c(
                    "div",
                    {
                      staticClass: "text-right"
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            text: "",
                            disabled: _vm.submitting
                          },
                          on: {
                            click: function click($event) {
                              _vm.deleteDialog = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            tile: "",
                            color: "error",
                            loading: _vm.submitting
                          },
                          on: {
                            click: _vm.deleteKey
                          }
                        },
                        [_vm._v("Remove")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }